/* Imports */
import React from 'react'

/* Social Functional Component */
function Social(props) {
  return (
    <props.icon className='text-white text-xl md:text-lg mr-6' />
  )
}

/* Export Component */
export default Social